import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { SetupEquipmentService } from '../setup-equipment.service';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../app.service';
import { LoadingService } from '../../../shared/services/loading.service';
import { MatDialogRef } from '@angular/material/dialog';
import { CryptoService } from '../../../services/crypto.service';

@Component({
  selector: 'app-request-new-model-popup',
  templateUrl: './request-new-model-popup.component.html',
  styleUrls: ['./request-new-model-popup.component.scss']
})
export class RequestNewModelPopupComponent implements OnInit {
  email = '';
  model = '';
  make = '';
  modelControl: FormControl;
  emailControl: FormControl;
  makeControl: FormControl;
  saving: boolean;
  fg: FormGroup;
  constructor(
    private _formBuilder: FormBuilder,
    private _equipmentService: SetupEquipmentService,
    private _notification: NotificationsService,
    private _appService: AppService,
    private _loading: LoadingService,
    public dialogRef: MatDialogRef<RequestNewModelPopupComponent>,
    private cryptoService: CryptoService
    ) { }

  ngOnInit() {
    this._loading.startLoading();
    this._equipmentService.getUserEmail().subscribe(r => {
      this._loading.finishedLoading();
      this.email = this.cryptoService.decrypt(r)?.trim();
    } );
    this.emailControl = new FormControl(this.email, [
      Validators.required,
      Validators.email,
    ]);
    this.modelControl = new FormControl(this.model, [
      Validators.required,
    ]);
    this.makeControl = new FormControl(this.make, [
      Validators.required,
    ]);
    this.fg = new FormGroup({
      modelControl: this.modelControl,
    });
  }

  save() {
    this._loading.startLoading();
    this.saving = true;
    this._equipmentService.requestANewModelEmailSend(this.email, this.model,this.make).subscribe(r => {
      this.saving = false;
      if (r) {
        this._loading.finishedLoading();
        this._notification.success('Success', 'We will contact you shortly');
        this.dialogRef.close();
      }      
      else{
        this._loading.finishedLoading();
        this._notification.error('Operation Failed');
      }
    }, error => {
      this.saving = false;
      this._loading.finishedLoading();
      this._notification.error('Operation Failed');
      console.log(error);
    });
  }
  
  onNoClick() {
    this.dialogRef.close();
  }
}
